import React, { useState } from "react";
import { Link } from "react-router-dom";
import AuthShell from "@/components/layout/AuthShell";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { Loader2, AlertCircle, MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Reset your password"
      subtitle="Enter your email and we'll send a reset link."
      footer={<><Link to="/sign-in" className="font-semibold text-ff-red hover:underline">Back to sign in</Link></>}
    >
      {sent ? (
        <div className="flex flex-col items-center py-6 text-center" data-testid="forgot-success">
          <MailCheck className="mb-4 h-12 w-12 text-ff-green" />
          <p className="text-sm text-ff-dark">
            If an account exists for <span className="font-semibold">{email}</span>, a reset link has been sent.
            Check your inbox (and the server console in this demo).
          </p>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-5" data-testid="forgot-form">
          {error && (
            <Alert variant="destructive"><AlertCircle className="h-4 w-4" /><AlertDescription>{error}</AlertDescription></Alert>
          )}
          <div>
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" required data-testid="forgot-email-input" value={email}
              onChange={(e) => setEmail(e.target.value)} className="mt-1.5" placeholder="you@example.com" />
          </div>
          <Button type="submit" disabled={loading} data-testid="forgot-submit-button"
            className="w-full bg-ff-action font-semibold text-white hover:bg-ff-actionDark">
            {loading ? <><Loader2 className="mr-2 h-4 w-4 animate-spin" /> Sending</> : "Send Reset Link"}
          </Button>
        </form>
      )}
    </AuthShell>
  );
}
